import type { IAccountNotificationsClientPortal } from './AccountNotificationsClientPortal.interface';
import AccountNotificationsPreferences from './AccountNotificationsPreferences';

export default class AccountNotificationsClientPortal
  implements IAccountNotificationsClientPortal {
  clientLoggedIn: AccountNotificationsPreferences;
  clientMyUpdated: AccountNotificationsPreferences;
  clientUpdated: AccountNotificationsPreferences;

  static build = (data: IAccountNotificationsClientPortal) =>
    new AccountNotificationsClientPortal(data);

  static blank = () => new AccountNotificationsClientPortal();

  /**
   * Constructor
   * @param {IAccountNotificationsClientPortal} data
   */
  constructor(data?: IAccountNotificationsClientPortal) {
    this.clientLoggedIn = new AccountNotificationsPreferences(data?.clientLoggedIn);
    this.clientMyUpdated = new AccountNotificationsPreferences(data?.clientMyUpdated);
    this.clientUpdated = new AccountNotificationsPreferences(data?.clientUpdated);
  }
}
